export const BOOKSY_PAY_SETTINGS_ENDPOINT = '/core/v2/business_api/me/businesses/{businessId}/pos/booksy_pay_settings/'
